export default __webpack_public_path__ + "tag-black-shape.png";